var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDroplets03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.967 5.066a9.143 9.143 0 0 0 1.2-2.983c.416 2.083 1.666 4.083 3.333 5.417 1.667 1.333 2.5 2.916 2.5 4.583a5.816 5.816 0 0 1-9.925 4.142M6.333 13.15c1.834 0 3.334-1.525 3.334-3.375 0-.967-.475-1.884-1.425-2.659-.95-.775-1.667-1.925-1.909-3.133a5.487 5.487 0 0 1-1.908 3.133C3.467 7.883 3 8.816 3 9.775c0 1.85 1.5 3.375 3.333 3.375z",
    stroke: "#667085",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroplets03);
export default __webpack_public_path__ + "static/media/droplets03.5f917e1eb39281abb469fcf3b2f48d1b.svg";
export { ForwardRef as ReactComponent };